// src/hooks/useFetchUserMe.js
import { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { Enviroments } from "../enviroments/enviroments";
import { cactusApi } from "../services/cactusApi"; // Importando o serviço centralizado

const useFetchUserMe = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const apiIA = Enviroments.API_URL_IA;

  const logout = () => {
    localStorage.clear();
    history.push("/auth/login");
  };

  const fetchUserMe = async () => {
    setLoading(true);
    try {
      const casinoToken = localStorage.getItem("casinoToken") || localStorage.getItem("apiToken");
      if (!casinoToken) throw new Error("Token ausente.");

      // 1️⃣ Busca o perfil na Cactus API via serviço centralizado
      const meResponse = await cactusApi.getUser();

      const userData = meResponse?.data || {};
      setData(userData);

      // salva infos principais localmente
      const cpf = userData?.document?.number?.replace(/\D/g, "") || "";
      
      // Cálculo do saldo: balance + credit do wallet (dividir por 100 se vier em centavos, 
      // mas pelo exemplo credit=2488.1 parece float, enquanto wallet.credit=248810 pode ser centavos.
      // Vou somar balance + credit do objeto wallet e garantir formato float.
      const wallet = userData?.wallet || {};
      const rawBalance = Number(wallet.balance || 0);
      const rawCredit = Number(wallet.credit || 0);
      // Pelo JSON de exemplo: wallet.credit = 248810 e _cached.get-credits.credit = 2488.1
      // Isso sugere que wallet.credit está em centavos.
      const totalBalance = (rawBalance + rawCredit) / 100;

      localStorage.setItem("id", userData?.id || "");
      localStorage.setItem("cpf", cpf);
      localStorage.setItem("email", userData?.email || "");
      localStorage.setItem("name", userData?.name || "");
      localStorage.setItem("phone", userData?.phone || "");
      localStorage.setItem("balance", String(totalBalance)); // Salva o saldo calculado

      // 2️⃣ BRIDGE: emite JWT interno e garante role/id atualizados
      try {
        const bridgeRes = await axios.post(`${apiIA}auth/bridge`, {
          access_token: casinoToken,
          profile: userData,
        });

        const backendUser = bridgeRes?.data?.user || {};
        localStorage.setItem("id", backendUser?.id || localStorage.getItem("id") || "");
        localStorage.setItem("role", backendUser?.role || "user");
        localStorage.setItem("apiJwt", bridgeRes?.data?.token || "");
        localStorage.setItem("subscription_status", backendUser?.subscription_status || "");
      } catch (bridgeErr) {
        console.warn("Falha no bridge com backend:", bridgeErr?.message);
      }

      setError(null);
    } catch (err) {
      console.error("Erro em useFetchUserMe:", err?.response?.data || err.message);
      setError(err.response ? err.response.data : err.message);
      setData(null);
      // se o token expirou ou foi removido, força logout
      setTimeout(() => logout(), 1500);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserMe();
  }, []);

  return { data, error, loading, refetch: fetchUserMe, logout };
};

export default useFetchUserMe;
